import React from "react";
import getCorsi from "../services/getCorsi";
import getChiusura from "../services/getChiusura";
import getSessioniLezione from "../services/getSessioniLezione";
import moment from "moment";
import Cookies from "universal-cookie";

/**
 * GridSchedule aggiornato per supportare visualizzazione basata su periodo corso
 * invece che anno solare. Versione semplificata senza suddivisioni interne.
 */
export default class GridScheduleEnhanced extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chiusura: [],
      sessioniPerLezione: {}, // Cache delle sessioni per ogni lezione
    };
  }

  async componentDidMount() {
    // Carica i giorni di chiusura una volta
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    if (username && token) {
      const chiusura = await getChiusura(username, token);
      this.setState({ chiusura });

      // Carica le sessioni per tutte le lezioni
      await this.loadSessioniLezioni(username, token);
    }
  }

  async componentDidUpdate(prevProps) {
    // Ricarica le sessioni se le lezioni cambiano
    if (prevProps.lezioni !== this.props.lezioni) {
      const cookies = new Cookies();
      const username = cookies.get("username", { path: "/" });
      const token = cookies.get("token", { path: "/" });
      if (username && token) {
        await this.loadSessioniLezioni(username, token);
      }
    }
  }

  async loadSessioniLezioni(username, token) {
    const lezioni = this.props.lezioni || [];
    const sessioniPerLezione = {};

    // Carica le sessioni per ogni lezione in parallelo
    const promises = lezioni.map(async (lezione) => {
      try {
        const sessioni = await getSessioniLezione(username, token, lezione.id);
        if (sessioni && sessioni.length > 0) {
          sessioniPerLezione[lezione.id] = sessioni;
        }
      } catch (error) {
        console.error(
          `Errore caricamento sessioni per lezione ${lezione.id}:`,
          error
        );
      }
    });

    await Promise.all(promises);
    this.setState({ sessioniPerLezione });
  }

  // Verifica se una data è in un periodo di chiusura
  isDataInChiusura(dataLezione) {
    return this.state.chiusura.some((c) => {
      const dataChiusura = moment(c.day, "DD-MM-YYYY");
      const lezioneDate = moment(dataLezione, "YYYY-MM-DD HH:mm:ss");
      return (
        lezioneDate.format("YYYY-MM-DD") === dataChiusura.format("YYYY-MM-DD")
      );
    });
  }
  renderLessonBlock(lezione) {
    const data = lezione.data;

    // Verifica se la lezione ha sessioni (lezione divisa)
    const sessioni = this.state.sessioniPerLezione[lezione.id] || [];
    const haSessioni = sessioni.length > 0;

    let nomiInsegnanti = [];
    let nomiMaterie = [];
    let orariSessioni = []; // Array per gli orari delle sessioni

    if (haSessioni) {
      // Lezione divisa in sessioni - raccoglie info da tutte le sessioni
      const sessioniOrdinate = sessioni.sort((a, b) => a.ordine - b.ordine);

      sessioniOrdinate.forEach((sessione, index) => {
        // Insegnanti della sessione
        const idInsegnanti = (sessione.id_insegnanti || "")
          .split(",")
          .filter((id) => id.trim());
        const insegnantiSessione = this.props.insegnanti.filter((insegnante) =>
          idInsegnanti.includes(insegnante.id.toString())
        );
        const nomiInsegnantiSessione = insegnantiSessione.map(
          (ins) => ins.nome + " " + ins.cognome
        );

        // Materie della sessione
        const idMaterie = (sessione.id_materia || "")
          .split(",")
          .filter((id) => id.trim());
        const materieSessione = this.props.materie.filter((materia) =>
          idMaterie.includes(materia.id.toString())
        );
        const nomiMaterieSessione = materieSessione.map(
          (materia) => materia.materia
        );

        // Aggiungi con label della sessione e orario
        const labelSessione = sessione.ordine === 1 ? "1ª metà" : "2ª metà";
        const orarioSessione =
          sessione.ora_inizio && sessione.ora_fine
            ? `${sessione.ora_inizio}-${sessione.ora_fine}`
            : "";

        // Salva orari per visualizzazione
        orariSessioni.push({
          label: labelSessione,
          ora_inizio: sessione.ora_inizio,
          ora_fine: sessione.ora_fine,
        });

        if (nomiInsegnantiSessione.length > 0) {
          nomiInsegnanti.push({
            label: labelSessione,
            orario: orarioSessione,
            nomi: nomiInsegnantiSessione.join(", "),
          });
        }
        if (nomiMaterieSessione.length > 0) {
          nomiMaterie.push({
            label: labelSessione,
            nomi: nomiMaterieSessione.join(", "),
          });
        }
      });
    } else {
      // Lezione intera - usa i dati della lezione principale
      const idInsegnanti = (lezione.id_insegnanti || "")
        .split(",")
        .filter((id) => id.trim());
      const insegnantiSelezionati = this.props.insegnanti.filter((insegnante) =>
        idInsegnanti.includes(insegnante.id.toString())
      );
      nomiInsegnanti = insegnantiSelezionati.map(
        (ins) => ins.nome + " " + ins.cognome
      );

      const idMaterie = (lezione.id_materia || "")
        .split(",")
        .filter((id) => id.trim());
      const materiaSelezionata = this.props.materie.filter((materia) =>
        idMaterie.includes(materia.id.toString())
      );
      nomiMaterie = materiaSelezionata.map((materia) => materia.materia);
    }

    // Controllo per il pagamento quota
    const pagamentoQuota =
      lezione.pagamento_quota === "1" || lezione.pagamento_quota === 1;

    // Verifica se è una scadenza (pagamento quota in periodo di chiusura)
    const isScadenzaPagamento = pagamentoQuota && this.isDataInChiusura(data);

    // Formatta la data - per sessioni usa l'orario della prima sessione
    const formatLezioneDate = (dataStr, sessioniOrari) => {
      const dataOnly = moment(dataStr, "YYYY-MM-DD HH.mm").format("DD-MM-YYYY");

      if (sessioniOrari && sessioniOrari.length > 0) {
        // Per lezioni divise, mostra data + orario della prima sessione
        const primaSessione = sessioniOrari[0];
        const oraInizio = primaSessione.ora_inizio || "";
        return `${dataOnly} ore ${oraInizio}`;
      } else {
        // Per lezioni intere, mostra data e ora
        return moment(dataStr, "YYYY-MM-DD HH.mm").format(
          "DD-MM-YYYY [ore] HH:mm"
        );
      }
    };

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: isScadenzaPagamento
            ? "#ffe6e6"
            : haSessioni
            ? "#e8f4e8"
            : "#ddeeff", // Verde chiaro per sessioni
          padding: "4px",
          boxSizing: "border-box",
          cursor: "pointer",
          border: isScadenzaPagamento
            ? "2px solid #a00308"
            : haSessioni
            ? "1px solid #28a745"
            : "1px solid #ccc",
        }}
        onClick={() =>
          this.props.onMouseClick(moment(data).format("YYYY-MM-DD"), "")
        }
      >
        <p
          style={{
            fontWeight: "bold",
            fontSize: "12px",
            margin: 0,
            color: isScadenzaPagamento ? "#a00308" : "#333",
          }}
        >
          {formatLezioneDate(data, orariSessioni)}
          {haSessioni && (
            <span
              style={{ fontSize: "10px", color: "#28a745", marginLeft: "5px" }}
            >
              (Divisa)
            </span>
          )}
        </p>

        {isScadenzaPagamento ? (
          // Visualizzazione per scadenza pagamento (pagamento quota in chiusura)
          <div>
            <p
              style={{
                fontSize: "12px",
                margin: "2px 0",
                color: "#a00308",
                fontWeight: "bold",
              }}
            >
              💰 SCADENZA PAGAMENTO
            </p>
            <p
              style={{
                fontSize: "10px",
                margin: "2px 0",
                color: "#666",
                fontStyle: "italic",
              }}
            >
              (Non è una lezione)
            </p>
          </div>
        ) : (
          // Visualizzazione per lezione normale (anche con pagamento quota)
          <div>
            {haSessioni ? (
              // Visualizzazione per sessioni con orari
              <>
                {nomiInsegnanti.map((item, idx) => (
                  <p
                    key={`ins-${idx}`}
                    style={{ fontSize: "11px", margin: "2px 0", color: "#333" }}
                  >
                    <strong>{item.label}</strong> ({item.orario}): {item.nomi}
                  </p>
                ))}
                {nomiMaterie.map((item, idx) => (
                  <p
                    key={`mat-${idx}`}
                    style={{ fontSize: "10px", margin: "1px 0", color: "#555" }}
                  >
                    {item.label}: {item.nomi}
                  </p>
                ))}
              </>
            ) : (
              // Visualizzazione per lezione intera
              <>
                <p style={{ fontSize: "12px", margin: 0, color: "#333" }}>
                  {nomiInsegnanti.join(", ")}
                </p>
                {nomiMaterie.length > 0 ? (
                  <p
                    style={{
                      fontSize: "10px",
                      margin: "2px 0 0",
                      color: "#555",
                    }}
                  >
                    {nomiMaterie.join(", ")}
                  </p>
                ) : (
                  <p
                    style={{
                      fontSize: "10px",
                      margin: "2px 0 0",
                      color: "#555",
                    }}
                  >
                    Lezione
                  </p>
                )}
              </>
            )}
            {pagamentoQuota && (
              <p
                style={{
                  fontSize: "10px",
                  margin: "2px 0 0",
                  color: "#ffffff",
                  fontWeight: "bold",
                  backgroundColor: "#a00308",
                  padding: "1px 3px",
                  borderRadius: "3px",
                  display: "inline-block",
                }}
              >
                $ Pagamento
              </p>
            )}
          </div>
        )}
      </div>
    );
  }

  /**
   * Genera i mesi del corso completo (da dateStart a dateEnd)
   */
  generaMesiCorso() {
    const { corso } = this.props;

    if (!corso || !corso.dateStart || !corso.dateEnd) {
      // Fallback al comportamento originale se non specificato
      const currentYear = moment().year();
      return Array.from({ length: 12 }, (_, i) =>
        moment(`${currentYear}-${i + 1}`, "YYYY-M").format("YYYY-MM")
      );
    }

    const dataInizio = moment(corso.dateStart);
    const dataFine = moment(corso.dateEnd);

    const mesi = [];
    let meseCorrente = dataInizio.clone().startOf("month");

    while (meseCorrente.isSameOrBefore(dataFine, "month")) {
      mesi.push(meseCorrente.format("YYYY-MM"));
      meseCorrente.add(1, "month");
    }

    return mesi;
  }

  renderGrid() {
    const mesi = this.generaMesiCorso();
    const lezioni = this.props.lezioni || [];

    const lezioniPerMese = {};
    lezioni.forEach((lezione) => {
      const mese = moment(lezione.data).format("YYYY-MM");
      if (!lezioniPerMese[mese]) {
        lezioniPerMese[mese] = [];
      }
      lezioniPerMese[mese].push(lezione);
    });

    let rows = mesi.map((mese, index) => {
      const lezioniDelMese = lezioniPerMese[mese] || [];

      const lezioniDelMeseSorted = lezioniDelMese.sort((a, b) =>
        moment(a.data, "YYYY-MM-DD HH.mm").diff(
          moment(b.data, "YYYY-MM-DD HH.mm")
        )
      );

      let cells = [];
      for (let j = 0; j < 6; j++) {
        if (j < lezioniDelMeseSorted.length) {
          const lezione = lezioniDelMeseSorted[j];
          const cellContent = this.renderLessonBlock(lezione);
          cells.push(
            <div
              key={j}
              style={{
                flex: 1,
                minWidth: 150,
                minHeight: 100,
                border: "1px solid #aaa",
                boxSizing: "border-box",
              }}
            >
              {cellContent}
            </div>
          );
        } else {
          cells.push(
            <div
              key={j}
              style={{
                flex: 1,
                minWidth: 150,
                minHeight: 100,
                border: "1px solid #aaa",
                boxSizing: "border-box",
                cursor: "pointer",
              }}
              onClick={() => this.props.onMouseClick(mese, "")}
            />
          );
        }
      }

      // Evidenzia il mese corrente se nel periodo
      const isMeseCorrente = moment().format("YYYY-MM") === mese;
      const headerStyle = {
        textAlign: "left",
        fontWeight: "bold",
        fontSize: "14px",
        marginBottom: "4px",
        color: isMeseCorrente ? "#007bff" : "#333",
        backgroundColor: isMeseCorrente ? "#f8f9fa" : "transparent",
        padding: isMeseCorrente ? "4px 8px" : "0",
        borderRadius: isMeseCorrente ? "4px" : "0",
      };

      return (
        <div key={index} style={{ marginBottom: "10px" }}>
          <div style={headerStyle}>
            {moment(mese, "YYYY-MM").format("MMMM YYYY")}
            {this.renderStatisticheMese(lezioniDelMese)}
          </div>
          <div style={{ display: "flex" }}>{cells}</div>
        </div>
      );
    });

    return rows;
  }

  /**
   * Renderizza statistiche per il mese (numero lezioni, ore totali, ecc.)
   */
  renderStatisticheMese(lezioniDelMese) {
    if (!lezioniDelMese || lezioniDelMese.length === 0) {
      return (
        <span
          style={{
            fontSize: "12px",
            color: "#6c757d",
            marginLeft: "10px",
            fontWeight: "normal",
          }}
        >
          (0 lezioni)
        </span>
      );
    }

    // Separiamo le lezioni vere dalle scadenze di pagamento
    // Lezioni vere: tutte le lezioni ECCETTO quelle con pagamento quota durante giorni di chiusura
    const lezioniVere = lezioniDelMese.filter((l) => {
      const pagamentoQuota =
        l.pagamento_quota === "1" || l.pagamento_quota === 1;

      // Se non è un pagamento quota, è sempre una lezione vera
      if (!pagamentoQuota) {
        return true;
      }

      // Se è un pagamento quota, è una lezione vera solo se NON è in un giorno di chiusura
      return !this.isDataInChiusura(l.data);
    });

    // Scadenze: tutti i pagamenti quota del mese (indipendentemente dai giorni di chiusura)
    const scadenzePagamento = lezioniDelMese.filter((l) => {
      const pagamentoQuota =
        l.pagamento_quota === "1" || l.pagamento_quota === 1;
      // Conta tutte le scadenze di pagamento del mese
      return pagamentoQuota;
    });

    const numeroLezioni = lezioniVere.length;
    const oreTotali = lezioniVere.reduce((total, lezione) => {
      return total + (parseInt(lezione.durata) || 0);
    }, 0);

    let testo = `(${numeroLezioni} lezioni`;
    if (numeroLezioni > 0) {
      testo += `, ${Math.round((oreTotali / 60) * 10) / 10}h`;
    }
    if (scadenzePagamento.length > 0) {
      testo += `, ${scadenzePagamento.length} scadenze`;
    }
    testo += ")";

    return (
      <span
        style={{
          fontSize: "12px",
          color: "#6c757d",
          marginLeft: "10px",
          fontWeight: "normal",
        }}
      >
        {testo}
      </span>
    );
  }

  render() {
    const { corso } = this.props;

    return (
      <div
        style={{
          width: "100%",
          maxWidth: 1400,
          margin: "0 auto",
          position: "relative",
        }}
      >
        {/* Header corso */}
        {corso && (
          <div
            style={{
              backgroundColor: "#e9ecef",
              padding: "10px 15px",
              borderRadius: "8px",
              marginBottom: "15px",
              fontSize: "14px",
              fontWeight: "bold",
              color: "#495057",
            }}
          >
            Calendario: {corso.nome || corso.name || "Corso"}
            {corso.dateStart && corso.dateEnd && (
              <span style={{ marginLeft: "10px", fontWeight: "normal" }}>
                ({moment(corso.dateStart).format("DD/MM/YYYY")} -{" "}
                {moment(corso.dateEnd).format("DD/MM/YYYY")})
              </span>
            )}
            {corso.anno_accademico && (
              <span
                style={{
                  marginLeft: "10px",
                  fontWeight: "normal",
                  fontSize: "12px",
                }}
              >
                - Anno Accademico: {corso.anno_accademico}
              </span>
            )}
          </div>
        )}

        {this.renderGrid()}

        {/* Footer con statistiche totali corso */}
        {this.renderStatisticheCorso()}
      </div>
    );
  }

  /**
   * Renderizza statistiche totali del corso
   */
  renderStatisticheCorso() {
    const lezioni = this.props.lezioni || [];

    if (!lezioni || lezioni.length === 0) {
      return (
        <div
          style={{
            textAlign: "center",
            padding: "15px",
            color: "#6c757d",
            fontSize: "14px",
            border: "1px dashed #dee2e6",
            borderRadius: "8px",
            marginTop: "20px",
          }}
        >
          Nessuna lezione pianificata per questo corso
        </div>
      );
    }

    // Separiamo le lezioni vere dalle scadenze di pagamento
    // Lezioni vere: tutte le lezioni ECCETTO quelle con pagamento quota durante giorni di chiusura
    const lezioniVere = lezioni.filter((l) => {
      const pagamentoQuota =
        l.pagamento_quota === "1" || l.pagamento_quota === 1;

      // Se non è un pagamento quota, è sempre una lezione vera
      if (!pagamentoQuota) {
        return true;
      }

      // Se è un pagamento quota, è una lezione vera solo se NON è in un giorno di chiusura
      return !this.isDataInChiusura(l.data);
    });

    // Scadenze: tutti i pagamenti quota del corso (indipendentemente dai giorni di chiusura)
    const scadenzePagamento = lezioni.filter((l) => {
      const pagamentoQuota =
        l.pagamento_quota === "1" || l.pagamento_quota === 1;
      // Conta tutte le scadenze di pagamento del corso
      return pagamentoQuota;
    });

    const numeroTotaleLezioni = lezioniVere.length;
    const oreTotaliCorso = lezioniVere.reduce((total, lezione) => {
      return total + (parseInt(lezione.durata) || 0);
    }, 0);

    return (
      <div
        style={{
          backgroundColor: "#f8f9fa",
          padding: "15px",
          borderRadius: "8px",
          marginTop: "20px",
          border: "1px solid #dee2e6",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            fontSize: "14px",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: "bold", color: "#007bff" }}>
              {numeroTotaleLezioni}
            </div>
            <div style={{ color: "#6c757d" }}>Lezioni effettive</div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: "bold", color: "#28a745" }}>
              {Math.round((oreTotaliCorso / 60) * 10) / 10}h
            </div>
            <div style={{ color: "#6c757d" }}>Ore di lezione</div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: "bold", color: "#a00308" }}>
              {scadenzePagamento.length}
            </div>
            <div style={{ color: "#6c757d" }}>Scadenze pagamento</div>
          </div>
        </div>
      </div>
    );
  }
}
